/**
 * File-type mapping shared by the drive's glyphs, previews and list rows.
 *
 * `color` is the body of the folded-corner document glyph, `fold` the lighter
 * triangle in its top-right corner. Both come straight from the Documents
 * module design.
 */
const KINDS = {
  pdf: { kind: "pdf", label: "PDF", typeLabel: "PDF", color: "#E5252A", fold: "#F07B7F" },
  doc: { kind: "doc", label: "DOC", typeLabel: "Word", color: "#2B7CD3", fold: "#82B6EA" },
  xls: { kind: "xls", label: "XLS", typeLabel: "Excel", color: "#1E9E5A", fold: "#82CFA6" },
  img: { kind: "img", label: "JPG", typeLabel: "Image", color: "#7E57C2", fold: "#B9A3DE" },
  other: { kind: "other", label: "FILE", typeLabel: "File", color: "#667085", fold: "#B0B7C3" },
};

const EXT_KIND = {
  pdf: "pdf",
  doc: "doc",
  docx: "doc",
  rtf: "doc",
  xls: "xls",
  xlsx: "xls",
  csv: "xls",
  jpg: "img",
  jpeg: "img",
  png: "img",
  gif: "img",
  webp: "img",
  bmp: "img",
};

// The S3 key keeps the original extension even after a rename, so it is the
// more reliable of the two — but the display name is what the user sees, so
// prefer it whenever it carries an extension we recognise.
export const extensionOf = (file) => {
  const fromName = file?.name?.split(".").pop()?.toLowerCase();
  if (fromName && EXT_KIND[fromName]) return fromName;
  const fromUrl = file?.fileUrl?.split("?")[0]?.split(".").pop()?.toLowerCase();
  if (fromUrl && EXT_KIND[fromUrl]) return fromUrl;
  return fromName || fromUrl || "";
};

export const fileTypeOf = (file) => {
  const ext = extensionOf(file);
  const base = KINDS[EXT_KIND[ext]] || KINDS.other;
  // Images are labelled with their real extension (JPG, PNG…) rather than a
  // generic one; every other type has a fixed three-letter label.
  if (base.kind === "img" || base.kind === "other") {
    return { ...base, label: (ext || base.label).toUpperCase().slice(0, 4) };
  }
  return base;
};

export default KINDS;
